import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styles from "./style.module.css";

const Dialog = ({ children, open, onClose, maxWidth = "500px" }) => {
  const [isVisible, setIsVisible] = useState(open);

  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => setIsVisible(true), 0);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [open]);

  if (!open) return null;

  return ReactDOM.createPortal(
    <div
      className={`${styles.dialog} ${
        isVisible ? styles.visible : styles.hidden
      }`}
    >
      <div className={`${styles.dialog_overlay} `} onClick={onClose} />
      <div className={styles.dialog_content} style={{ maxWidth: maxWidth }}>
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Dialog;
